import type { Role } from '../hooks/use-roles';

export const ROLE_HOME: Record<Role, string> = {
  teacher: '/teacher',
  admin: '/admin',
  direction: '/direction',
  tutor: '/tutor',
  eleve: '/mini-apps',
  ai_operator: '/admin/conversations',
};

export type AppDestination =
  | { kind: 'pending' }
  | { kind: 'unmapped' }
  | { kind: 'home'; path: string };

export function resolveAppDestination(activeRole: Role | null, available: readonly Role[]): AppDestination {
  if (available.length === 0) return { kind: 'pending' };
  const path = activeRole ? ROLE_HOME[activeRole] : undefined;
  return path ? { kind: 'home', path } : { kind: 'unmapped' };
}
